<div class="error-log-header">
  <span class="icon"></span> {{ 'APPLAYOUT.HEADER.ERROR_LOG.LABEL' | translate }}
</div>
